export default __webpack_public_path__ + "static/performance-48fe5446a0da345a44df5bcac57d3065.jpg";